/** The last answer that finished streaming — the baseline for AGENT_SESSION_ABANDON (D8). */
export interface LastAnswer {
  conversationId: string;
  interactionTimestamp: string;
  completedAtMs: number;
  /** Copied, downloaded, voted or regenerated since. */
  actedSince: boolean;
}

// Module scope: nothing renders this, and in the context it would re-render every action row.
let lastAnswer: LastAnswer | null = null;

export const getLastAnswer = (): LastAnswer | null => lastAnswer;

export const setLastAnswer = (value: LastAnswer | null): void => {
  lastAnswer = value;
};

export const markActedOnLastAnswer = (conversationId: string, interactionTimestamp: string): void => {
  if (!lastAnswer || lastAnswer.actedSince) return;
  // Acting on an older answer says nothing about the latest one.
  if (lastAnswer.conversationId !== conversationId || lastAnswer.interactionTimestamp !== interactionTimestamp) return;
  lastAnswer = { ...lastAnswer, actedSince: true };
};

export const ABANDON_WINDOW_MS = 10_000;

// One answer is abandoned once, however often the user hides the tab.
const reportedAbandons = new Set<string>();

export const resetAbandonReportsForTests = (): void => reportedAbandons.clear();

/** The answer to report as abandoned, or null; claiming it consumes the report. */
export const claimAbandonReport = (now: number): LastAnswer | null => {
  if (!lastAnswer || lastAnswer.actedSince) return null;
  if (now - lastAnswer.completedAtMs > ABANDON_WINDOW_MS) return null;
  const key = `${lastAnswer.conversationId}#${lastAnswer.interactionTimestamp}`;
  if (reportedAbandons.has(key)) return null;
  reportedAbandons.add(key);
  return lastAnswer;
};
